import React from 'react';

import Button from 'components/Button.jsx';
import CurrentUser from 'auth/CurrentUser';
import DeliveryModal from 'chat/components/DeliveryModal.jsx';
import DeliveryStore from 'stores/DeliveryStore';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import GroupName from 'groups/components/GroupName.jsx';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import GroupStore from 'groups/stores/GroupStore';
import LayerTrigger from 'components/LayerTrigger.jsx';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import Menu from 'components/Menu.jsx';
import MenuItem from 'components/MenuItem.jsx';
import Message from 'entities/Message';
import ModalTrigger from 'components/ModalTrigger.jsx';
import ReadReceipt from 'chat/components/ReadReceipt.jsx';
import RelationshipModal from 'user/components/RelationshipModal.jsx';
import StatusLabel from 'components/StatusLabel.jsx';
import Text from 'components/Text.jsx';
import Time from 'components/Time.jsx';
import Timestamp from 'components/Timestamp.jsx';
import { mountModal } from 'lib/modal';

import './styles/GroupMessageInformation.scss';

const GroupMessageInformation = React.createClass({
  propTypes: {
    showReadReceipt: React.PropTypes.bool,
  },

  contextTypes: {
    group: React.PropTypes.instanceOf(Group),
    message: React.PropTypes.instanceOf(Message).isRequired,
  },

  mixins: [
    linkStateWithStores([DeliveryStore]),
  ],

  getInitialState() {
    return this.getStateFromStores();
  },

  getStateFromStores() {
    return {
      readReceipt: DeliveryStore.getDeliveryByMessageId(this.context.message.getUuid()),
    };
  },

  renderReadReceipt() {
    const summary = this.state.readReceipt.getReadSummary();
    const openReadReceiptModal = () => {
      mountModal(<DeliveryModal message={this.context.message} />, this);
    };

    return summary.getState() && (
      <div className="GroupMessageInformation-readreceipt">
        <ReadReceipt
          labelDisplay
          glyphDisplay
          onClick={openReadReceiptModal}
          status={summary.getState()}
          errorCount={summary.getFailedCount()}
        />
      </div>
    );
  },

  renderRecipients() {
    const { group } = this.context;
    if (!group || !group.isOwnedByUser(CurrentUser.getUserId())) {
      return null;
    }

    const { message } = this.context;
    const recipients = message.getRecipients();
    if (recipients.length <= 1) {
      return null;
    }

    return (
      <div className="GroupMessageInformation-recipients">
        <span className="GroupMessageInformation-bullet">•</span>
        <LayerTrigger
          layer={this.renderRecipientsDropdown()}
          trigger="click"
          placement="bottom"
          alignment="middle">
          <Button
            className="GroupMessageInformation-recipients-button"
            level="text"
            size="small"
            eventElementName="GroupMessageInformation-recipients-button">
            {this.renderRecipientsLabel()}
          </Button>
        </LayerTrigger>
      </div>
    );
  },

  renderRecipientsDropdown() {
    const { message } = this.context;
    const recipients = message.getRecipients();

    return (
      <Menu>
        {recipients.map(recipient => {
          const id = recipient.id;
          if (recipient.isGroup()) {
            const group = GroupStore.getGroup(id);
            if (group) {
              return (
                <MenuItem
                  key={id}
                  className="GroupMessageInformation-recipient"
                  to={`/classes/${group.getCode()}`}>
                  <GroupAvatar
                    className="GroupMessageInformation-recipient-avatar"
                    group={group}
                  />
                  <Text className="GroupMessageInformation-recipient-name" truncate>
                    <GroupName group={group} />
                  </Text>
                </MenuItem>
              );
            }
          }

          if (recipient.isSubscriber()) {
            return (
              <ModalTrigger modal={<RelationshipModal userId={id} />}>
                <MenuItem key={id} className="GroupMessageInformation-recipient">
                  <Text className="GroupMessageInformation-recipient-name" truncate>
                    {recipient.getName()}
                  </Text>
                </MenuItem>
              </ModalTrigger>
            );
          }

          let status;
          if (recipient.isDeleted()) {
            status = (
              <StatusLabel className="GroupMessageInformation-recipient-status">
                Deleted
              </StatusLabel>
            );
          }

          return (
            <MenuItem
              key={id}
              className="GroupMessageInformation-recipient"
              disabled>
              <Text className="GroupMessageInformation-recipient-name" truncate>
                {recipient.getName()}
              </Text>
              {status}
            </MenuItem>
          );
        })}
      </Menu>
    );
  },

  renderRecipientsLabel() {
    const { message } = this.context;
    const recipients = message.getRecipients();
    const { group, subscriber } = recipients.getCounts();

    let label;
    // FIXME: Sigh. This alone makes me want to do the work involved to get Intl.MessageFormat's
    // pluralization working with our i18n tool.
    if (message.getStatus() === 'scheduled') {
      label = group === 1 ?
        'Sending to 1 class' :
        `Sending to ${group} classes`;
    } else {
      if (group === 1) {
        if (subscriber === 1) {
          label = 'Sent to 1 class and 1 person';
        } else if (subscriber > 1) {
          label = `Sent to 1 class and ${subscriber} people`;
        } else {
          label = 'Sent to 1 class';
        }
      } else if (group > 1) {
        if (subscriber === 1) {
          label = `Sent to ${group} classes and 1 person`;
        } else if (subscriber > 1) {
          label = `Sent to ${group} classes and ${subscriber} people`;
        } else {
          label = `Sent to ${group} classes`;
        }
      } else {
        if (subscriber === 1) {
          label = `Sent to ${subscriber} person`;
        } else if (subscriber > 1) {
          label = `Sent to ${subscriber} people`;
        }
      }
    }
    return label;
  },

  renderTimestamp() {
    const { message } = this.context;

    if (message.getStatus() === 'failed') {
      return (
        <div className="GroupMessageInformation-timestamp">
          <span className="GroupMessageInformation-failed">
            An error has occurred. Please edit your message and send again.
          </span>
        </div>
      );
    }

    let time;
    let date;
    let glyph;
    if (message.getStatus() === 'scheduled') {
      time = <Time date={message.getSendAt()} hour="numeric" minute="2-digit" />;
      date = <Time date={message.getSendAt()} day="numeric" month="long" year="numeric" />;
      glyph = <Glyph className="GroupMessageInformation-clock" name="schedule" size="small" />;
    } else {
      time = <Time date={message.getSentAt()} hour="numeric" minute="2-digit" />;
      date = <Timestamp date={message.getSentAt()} />;
    }

    return (
      <div className="GroupMessageInformation-timestamp">
        {glyph}
        {date}{' at '}{time}
      </div>
    );
  },

  render() {
    const shouldRenderReadReceipt = (
      this.props.showReadReceipt &&
      this.state.readReceipt
    );

    return (
      <div className="GroupMessageInformation">
        {this.renderTimestamp()}
        {CurrentUser.isSignedIn() && shouldRenderReadReceipt && this.renderReadReceipt()}
        {CurrentUser.isSignedIn() && this.renderRecipients()}
      </div>
    );
  },
});

export default GroupMessageInformation;



// WEBPACK FOOTER //
// ./src/groups/components/GroupMessageInformation.jsx